import script from "./StageRace.vue?vue&type=script&setup=true&lang=js"
export * from "./StageRace.vue?vue&type=script&setup=true&lang=js"

import "./StageRace.vue?vue&type=style&index=0&id=1e0b3baf&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0b3baf"]])

export default __exports__